import { useNavigate } from 'react-router-dom';

export function useAdminAuth() {
  const navigate = useNavigate();
  
  const getAdminPassword = () => {
    return sessionStorage.getItem('adminPassword');
  };

  const isAuthenticated = () => {
    return !!getAdminPassword();
  };

  const requireAuth = () => {
    if (!isAuthenticated()) {
      navigate('/admin/login');
      return false;
    }
    return true;
  };

  const logout = () => {
    sessionStorage.removeItem('adminPassword');
    navigate('/admin/login');
  };

  const getAuthHeaders = () => {
    const password = getAdminPassword();
    if (!password) return {};
    
    return {
      'X-Admin-Password': password
    };
  };

  return {
    isAuthenticated,
    requireAuth,
    logout,
    getAuthHeaders,
    getAdminPassword
  };
}
